var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetpasswordlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 152,
    viewBox: "0 0 116 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.053 17.3638L57.9037 0L11.219 17.1351C5.25773 20.0256 0.03125 21.7516 0.03125 27.4494V55.8068C0.03125 75.4997 5.06364 95.0123 15.4126 112.238C24.1188 126.732 37.6078 141.662 58.3681 151.152C77.451 144.796 91.6956 127.841 100.409 113.347C110.758 96.1214 115.79 76.6018 115.79 56.9159V31.4143C115.79 23.2904 111.596 19.3255 105.06 17.3707L105.053 17.3638Z",
    fill: "#FFE0DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6976 87.9286H78.0331V40.7794C78.0331 29.6818 69.0011 20.6498 57.9035 20.6498C46.8059 20.6498 37.774 29.6818 37.774 40.7794V87.9286H29.1094V40.7794C29.1094 24.9059 42.0231 11.9922 57.8966 11.9922C73.7701 11.9922 86.6838 24.9059 86.6838 40.7794V87.9286H86.6976Z",
    fill: "#E8505B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M86.6976 87.9286H78.0331V40.7794C78.0331 29.6818 69.0011 20.6498 57.9035 20.6498C46.8059 20.6498 37.774 29.6818 37.774 40.7794V87.9286H29.1094V40.7794C29.1094 24.9059 42.0231 11.9922 57.8966 11.9922C73.7701 11.9922 86.6838 24.9059 86.6838 40.7794V87.9286H86.6976Z",
    fill: "#240630"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6821 66.9531H23.1367C20.9125 66.9531 19.1094 68.7562 19.1094 70.9804V112.709C19.1094 114.933 20.9125 116.736 23.1367 116.736H92.6821C94.9063 116.736 96.7093 114.933 96.7093 112.709V70.9804C96.7093 68.7562 94.9063 66.9531 92.6821 66.9531Z",
    fill: "#E8505B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.4058 85.3552C64.4058 81.7716 61.5014 78.8672 57.9177 78.8672C54.334 78.8672 51.4297 81.7716 51.4297 85.3552C51.4297 88.322 53.4329 90.7896 56.1432 91.566V101.263H59.6853V91.566C62.4025 90.7896 64.3988 88.322 64.3988 85.3552H64.4058Z",
    fill: "#240630"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetpasswordlock);
export default __webpack_public_path__ + "static/media/resetpasswordlock.eab695d5baa754eb884b163ca48da5ba.svg";
export { ForwardRef as ReactComponent };